import {
  AutocompletePopperSlotPropsOverrides,
  PopperProps,
} from '@mui/material';

import StyledAutocompletePopper from '@webclient/components/search-forms/gamification-search/actions/bots-selector/components/popper/styles';

type Props = PopperProps & AutocompletePopperSlotPropsOverrides;

export default function PopperComponent(Props: Omit<Props, 'children'>) {
  return <StyledAutocompletePopper {...Props} />;
}
